export enum AssessmentClickEventName {
  SEND = "SEND",
  ASSESS = "ASSESS",
}
